import React, { useState, useEffect } from 'react';

function PrivacyPolicyPage() {
  const [policyText, setPolicyText] = useState('');

  useEffect(() => {
    // The content of your Privacy Policy
    const fetchedPolicy = `
      <h2><strong>1. Information We Collect</strong></h2>
      <p>Bog Bot collects various types of information to provide its features and improve your experience:</p>
      <ul>
        <li><strong>Discord User Data:</strong>
          <ul>
            <li><strong>User IDs:</strong> Your unique Discord user identifier.</li>
            <li><strong>Usernames:</strong> Your Discord username.</li>
            <li><strong>Guild (Server) IDs:</strong> The unique identifier for the Discord servers where Bog Bot is active.</li>
            <li><strong>First Interaction Date:</strong> The date when you first interacted with Bog Bot.</li>
          </ul>
        </li>
        <li><strong>Interaction Data (Stored in Chroma DB):</strong>
          <ul>
            <li><strong>Message History:</strong> Content of chat messages in channels Bog Bot has access to, including text and attached images. This data is stored permanently on a per-server basis to facilitate the bot's long-term memory.</li>
            <li><strong>URLs:</strong> URLs shared in messages are stored as part of the message content within Chroma DB.</li>
            <li><strong>Relationship Levels:</strong> Data derived from your interactions, including sentiment analysis (using Google's sentiment analysis), is stored to track and adjust your unique "relationship level" with Bog Bot. This influences the bot's responses towards you.</li>
          </ul>
        </li>
        <li><strong>System Data:</strong>
          <ul>
            <li><strong>Error Logs:</strong> Information about errors or issues encountered by the bot for debugging and improvement purposes.</li>
            <li><strong>Subscription-Related IDs:</strong> If applicable, user and guild IDs are stored in relation to premium subscriptions.</li>
          </ul>
        </li>
      </ul>

      <h2><strong>2. How We Use Your Information</strong></h2>
      <p>The information we collect is used solely for the following purposes:</p>
      <ul>
        <li><strong>Bot Functionality:</strong> To enable Bog Bot's core features, including:
          <ul>
            <li>Providing conversational responses based on long-term and short-term memory.</li>
            <li>Dynamically adjusting responses based on your relationship level with the bot.</li>
            <li>Processing and responding to commands.</li>
            <li>Generating and editing images and videos.</li>
            <li>Interpreting and using content from web links in conversations.</li>
            <li>Delivering premium features.</li>
          </ul>
        </li>
        <li><strong>Internal Analytics:</strong> To understand bot usage patterns, identify popular features, and monitor performance, which helps us improve the Service.</li>
      </ul>

      <h2><strong>3. How We Share Your Information</strong></h2>
      <p>We do not intentionally share or sell any user data collected by Bog Bot with third parties, except as described below or as required by law:</p>
      <ul>
        <li><strong>External APIs for AI Tasks:</strong>
          <ul>
            <li><strong>Google (Gemini, Imagen 3, Sentiment Analysis):</strong> Chat data, prompts for image generation, and text for sentiment analysis are sent to Google's API services (Gemini, Imagen 3, and Google's sentiment analysis tools) to power Bog Bot's AI capabilities. We do not send personally identifiable information (like your Discord username or ID) directly to these APIs unless it is explicitly part of the message content you provide.</li>
            <li><strong>Discord API:</strong> We interact with the Discord API to send and receive messages, manage server permissions, and access necessary user and server information to operate the bot.</li>
            <li><strong>Veo 2:</strong> Data related to video generation requests is processed by Veo 2 for premium users.</li>
            <li><strong>Other APIs (e.g., Spotify, YouTube, CoinMarketCap, Lavalink):</strong> When you use features that interact with these services (e.g., music playback, cryptocurrency price lookups), relevant data (like song requests or crypto symbols) may be sent to their respective APIs. We do not share personal user data with these services.</li>
          </ul>
        </li>
      </ul>

      <h2><strong>4. Data Retention</strong></h2>
      <p>All collected data, including message history, image history, relationship levels, user IDs, usernames, guild IDs, and first interaction dates, is <strong>retained indefinitely</strong>. This retention policy is necessary to ensure the continuous functionality of Bog Bot's long-term memory and dynamic relationship levels.</p>

      <h2><strong>5. Your Data Rights</strong></h2>
      <p>You have the right to request access to, correction of, or deletion of your personal data held by Bog Bot.</p>
      <ul>
        <li><strong>Data Removal Request:</strong> If you wish for your server's data to be removed from Bog Bot's memory, or if you wish for your individual data to be removed, please contact us via:
          <ul>
            <li>The <code>/feedback</code> command within the bot.</li>
            <li>Email: <code>bogaihelp@gmail.com</code></li>
          </ul>
        </li>
      </ul>
      <p>Please note that if you request deletion of your data and subsequently interact with Bog Bot again, your data will be collected again as it is necessary for the bot's core functionality and features like long-term memory and relationship levels.</p>

      <h2><strong>6. Data Security</strong></h2>
      <p>We take reasonable measures to protect the information collected by Bog Bot from unauthorized access, alteration, disclosure, or destruction. Bog Bot is hosted on a home server with limited access controls in place. However, no method of transmission over the Internet or method of electronic storage is 100% secure.</p>

      <h2><strong>7. Children's Privacy</strong></h2>
      <p>Bog Bot is intended for users who are at least 13 years of age, in compliance with Discord's Terms of Service. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13 without verification of parental consent, we will take steps to remove that information from our servers.</p>

      <h2><strong>8. Changes to This Privacy Policy</strong></h2>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on the Discord server where Bog Bot is used. You are advised to review this Privacy Policy periodically for any changes. Your continued use of the Service after any modifications to the Privacy Policy will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>

      <h2><strong>9. Contact Us</strong></h2>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>Via the <code>/feedback</code> command within Bog Bot.</li>
        <li>By email: <code>bogaihelp@gmail.com</code></li>
      </ul>
    `;
    setPolicyText(fetchedPolicy);
  }, []);

  return (
    <div style={{ minHeight: '100vh', marginLeft: "5%", marginRight:"5%", marginTop:'3%',  }}>
      <main>
      <h1 style={{color:'white'}}><strong>Bog Bot - Privacy Policy</strong></h1>
      <p style={{paddingBottom: '5%', color:'white'}}><strong>Last Updated:</strong> July 4, 2025</p>
      <div
        style={{
          overflowY: 'auto',
          padding: '10px',
          color: 'white',
        }}

        dangerouslySetInnerHTML={{ __html: policyText }}
      />

      </main>
    </div>
  );
}

export default PrivacyPolicyPage;
